import React, { useRef, useEffect } from "react";
import QRCode from "qrcode.react";
import TicketPageCSS from "./TicketPage.module.css";
import fadeLogo from "../assets/fadelogo.svg";

export default function Ticket({ userData, ticketContainerRef }) {
	return (
		<div
			ref={ticketContainerRef}
			className={TicketPageCSS.mainticket}>
			<div className={TicketPageCSS.ticketTitle}>
				<img
					src={fadeLogo}
					alt="logo"
				/>
			</div>
			<div className={TicketPageCSS.ticketBody}>
				<div className={TicketPageCSS.part}>
					<h2 className="text-center">TxE SUMMIT 2022</h2>
				</div>
				<div className={TicketPageCSS.part}>
					<div className={TicketPageCSS.partHolder}>
						{/* <p>Name:</p> */}
						<div className={TicketPageCSS.partInner}>
							<p>{userData?.firstName + " " + userData?.lastName}</p>
						</div>
					</div>
				</div>
				<div className={TicketPageCSS.part}>
					<div className={TicketPageCSS.partHolder}>
						{/* <p>Date:</p> */}
						<div className={TicketPageCSS.partInner}>
							<p>30•09•2022</p>
						</div>
					</div>
				</div>
				<div className={TicketPageCSS.part}>
					<div className={TicketPageCSS.partHolder}>
						{/* <p>Event Type:</p> */}
						<div className={TicketPageCSS.partInner}>
							<p>{userData?.trackInterest.toUpperCase()} </p>
						</div>
					</div>
				</div>
				<div className={TicketPageCSS.part}>
					<div className={TicketPageCSS.partHolder}>
						{/* <p>Event Address:</p> */}
						<div className={TicketPageCSS.partInner}>
							<p>Golden Heart Event centre, Emene</p>
						</div>
					</div>
				</div>
			</div>
			<div className={TicketPageCSS.ticketStub}>
				<small>Scan to check in</small>
				<QRCode
					value={userData?.id}
					size={100}
				/>
				{/* <small className="text-center">{userData?.id}</small> */}
			</div>
		</div>
	);
}
